import { Thread } from '../../types/threads/Thread'
import { SetThreadsAction, SET_THREADS } from './types'

export const setThreads = (payload: Thread[]): SetThreadsAction => ({
  type: SET_THREADS,
  payload
})
